import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { getUserTransaction } from 'src/axious/user-transactions'
import { UserTransactionType } from 'src/pages/HistoryOfTransactions/HistoryOfTransactions'
import { handleAxiosError } from 'src/utils/errorHandling'

export const useGetUserTransaction = () => {
  const { id } = useParams<{ id: string }>()

  const [userTransaction, setUserTransaction] = useState<UserTransactionType>({
    id: 0,
    user_id: 0,
    amount_stars: 0,
    commission: 0,
    type: 'INVESTMENT',
    from: '',
    recipient: '',
    created_at: '',
    ToUser: null,
    FromUser: null,
    Withdrawal: null,
  })

  useEffect(() => {
    async function getTransactions() {
      try {
        const transactionData = await getUserTransaction(Number(id))
        setUserTransaction(transactionData)
      } catch (err) {
        const errorMessage = handleAxiosError(err)
        console.log(errorMessage)
      }
    }

    getTransactions()
  }, [id])

  return { userTransaction }
}
